import React from "react";
import { StepButton } from "./StepButton";

export interface IStepLinkProps {
  enabled: boolean;
  isFirst: boolean;
  LinkComponent: React.ReactType;
}

export const StepLink: React.FC<IStepLinkProps> = ({ enabled, isFirst, LinkComponent }) => {
  return enabled ? (
    <LinkComponent>
      <StepButton enabled={enabled} isFirst={isFirst} />
    </LinkComponent>
  ) : (
    <StepButton enabled={enabled} isFirst={isFirst} />
  );
};
